// Types offered when adding a one-off expense (money already spent). The recurring
// ones (Rent, Utilities, Loans, Investments...) belong to Bills & Payments.
// "Lent" is money given to someone who will pay it back (they borrowed it from you).
// Keep in step with VALID_TYPES in server/index.js.
export const EXPENSE_TYPES = [
  "Food & Dining",
  "Groceries",
  "Rent",
  "Utilities",
  "Transport",
  "Health",
  "Education",
  "Shopping",
  "Entertainment",
  "Travel",
  "Personal Care",
  "Gifts & Donations",
  "Bills",
  "Family",
  "Purchase",
  "Lent",
  "Other",
];

// Types offered when adding a Bill & Payment.
export const BILL_TYPES = ["Bills", "Rent", "Utilities", "Insurance", "Tax", "Loans", "Investments", "Card", "Subscription", "Family", "Purchase"];

// Every type an expense entry can have, for editing and filtering existing ones.
export const ALL_EXPENSE_TYPES = [...new Set([...BILL_TYPES, ...EXPENSE_TYPES])];

// Money going out that isn't spending: lent (it comes back), borrowed money paid back
// ("Repaid") and credit card bill payments (the purchases were already counted).
// Made by the app's own actions, never picked in a form.
const NOT_SPENDING = new Set(["Lent", "Repaid", "Card payment"]);
export const isSpending = (bill) => !NOT_SPENDING.has(bill.type);

// Money received that isn't earnings: borrowed money has to be paid back.
export const isEarning = (income) => income.type !== "Borrowed";

// Keep in step with VALID_INCOME_TYPES in server/index.js.
export const INCOME_TYPES = ["Salary", "Payment", "Gift", "Borrowed", "Other"];
